import React, { ReactNode } from 'react'
import Box from 'src/components/Box/Box'
import { SlideWithFrozenExit } from 'src/components/TransitionWithFrozenExit/TransitionWithFrozenExit'
import { css } from 'styled-components'

export interface FloatingToolbarProps {
  visible: boolean
  className?: string
  children?: ReactNode | undefined
  noPadding?: boolean
  noColumnGap?: boolean
}

const FloatingToolbar: React.ForwardRefRenderFunction<
  HTMLDivElement,
  FloatingToolbarProps
> = (props, ref): React.ReactElement => {
  return (
    <SlideWithFrozenExit
      in={props.visible}
      direction="up"
      container={document.body}
      mountOnEnter
      unmountOnExit
    >
      <div
        ref={ref}
        className={props.className}
        css={css`
          position: fixed;
          bottom: 60px;
          left: 50%;
          z-index: 2;
        `}
      >
        <Box
          css={css`
            display: flex;
            align-items: center;
            ${props.noColumnGap
              ? css`
                  column-gap: 0px;
                `
              : css`
                  column-gap: 40px;
                `}
            ${props.noPadding
              ? css`
                  padding: 0px;
                `
              : css`
                  padding: 0 20px;
                `}
          transform: translate(-50%);
            background:
              linear-gradient(
                0deg,
                rgba(250, 250, 250, 0.85),
                rgba(250, 250, 250, 0.85)
              ),
              rgba(255, 255, 255, 0.05);
            backdrop-filter: blur(5px);
          `}
        >
          {props.children}
        </Box>
      </div>
    </SlideWithFrozenExit>
  )
}

export default React.forwardRef(FloatingToolbar)
